function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _classPrivateFieldInitSpec(e, t, a) { _checkPrivateRedeclaration(e, t), t.set(e, a); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateFieldGet(s, a) { return s.get(_assertClassBrand(s, a)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { createStorage, getValue, setValue } from 'ember-tracked-storage-polyfill';
var _storages = /*#__PURE__*/new WeakMap();
var _collection = /*#__PURE__*/new WeakMap();
var _TrackedObject_brand = /*#__PURE__*/new WeakSet();
export default class TrackedObject {
  static fromEntries(entries) {
    return new TrackedObject(Object.fromEntries(entries));
  }
  constructor(obj = {}) {
    _classPrivateMethodInitSpec(this, _TrackedObject_brand);
    _classPrivateFieldInitSpec(this, _storages, new Map());
    _classPrivateFieldInitSpec(this, _collection, createStorage(null, () => false));
    let proto = Object.getPrototypeOf(obj);
    let descs = Object.getOwnPropertyDescriptors(obj);
    let clone = Object.create(proto);
    for (let prop in descs) {
      Object.defineProperty(clone, prop, descs[prop]);
    }

    // eslint-disable-next-line @typescript-eslint/no-this-alias
    let self = this;
    return new Proxy(clone, {
      get(target, prop) {
        _assertClassBrand(_TrackedObject_brand, self, _readStorageFor).call(self, prop);
        return target[prop];
      },
      has(target, prop) {
        _assertClassBrand(_TrackedObject_brand, self, _readStorageFor).call(self, prop);
        return prop in target;
      },
      ownKeys(target) {
        getValue(_classPrivateFieldGet(_collection, self));
        return Reflect.ownKeys(target);
      },
      set(target, prop, value) {
        target[prop] = value;
        _assertClassBrand(_TrackedObject_brand, self, _dirtyStorageFor).call(self, prop);
        _assertClassBrand(_TrackedObject_brand, self, _dirtyCollection).call(self);
        return true;
      },
      deleteProperty(target, prop) {
        if (prop in target) {
          delete target[prop];
          _assertClassBrand(_TrackedObject_brand, self, _dirtyStorageFor).call(self, prop);
          _assertClassBrand(_TrackedObject_brand, self, _dirtyCollection).call(self);
        }
        return true;
      },
      getPrototypeOf() {
        return TrackedObject.prototype;
      }
    });
  }
}
function _readStorageFor(key) {
  let storage = _classPrivateFieldGet(_storages, this).get(key);
  if (storage === undefined) {
    storage = createStorage(null, () => false);
    _classPrivateFieldGet(_storages, this).set(key, storage);
  }
  getValue(storage);
}
function _dirtyStorageFor(key) {
  const storage = _classPrivateFieldGet(_storages, this).get(key);
  if (storage) {
    setValue(storage, null);
  }
}
function _dirtyCollection() {
  setValue(_classPrivateFieldGet(_collection, this), null);
}